import { createFileRoute } from '@tanstack/react-router'
import Login from '../../../containers/authentication'
import { loginSearchSchema } from './search-schemas'

export const Route = createFileRoute('/_unauthenticated/login/')({
  validateSearch: loginSearchSchema,
  component: Login
})
